import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '@app/_services';
import { EditService } from '@app/_services';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Kpi } from '@app/_models';
import { TextSlides } from '@app/_models';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { min } from 'rxjs/operators';

@Component({
  selector: 'app-edit',
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.component.css'],
})
export class EditComponent implements OnInit {
  apiUrl = null;
  editForm: FormGroup;
  editTextSlideForm: FormGroup;
  kpis: Observable<Kpi[]>;
  public kpi: any = [];
  public textSlides: any = [];
  public editKpi: any = [];
  public editTextSlide: any = [];
  loadingKpi = true;
  loadingTextSlide = true;
  isVisibleModal = false;
  isVisibleModalTextSlide = false;
  isConfirmLoading = false;
  modalLoading = false;
  modalTextSlideLoading = false;
  submitButtonLoading = false;
  submitTextSlideButtonLoading = false;
  sysLanguage: string = 'RO';

  constructor(
    private authenticationService: AuthenticationService,
    private editservice: EditService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private message: NzMessageService,
    private sanitizer: DomSanitizer
  ) {
    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(['/login']);
    }
    else if(this.authenticationService.currentUserInfo.role != 'admin')
    {
      this.router.navigate(['/']);
    }
    this.apiUrl = this.authenticationService.apiUrl;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    
    this.getKpis()
      .pipe()
      .subscribe((res) => {
        this.kpi = res.body;
        this.loadingKpi = false;
      });

    this.getTextSlides()
      .pipe()
      .subscribe((res) => {
        this.textSlides = res.body;
        this.loadingTextSlide = false;
      });

    this.editForm = this.formBuilder.group({
      id: [null],
      description: [null, [Validators.required]],
      benchmark: [null, [Validators.required]],
      greenDescription: [null],
      yellowDescription: [null],
      redDescription: [null],
    });

    this.editTextSlideForm = this.formBuilder.group({
      id: [null],
      title: [null, [Validators.required]],
      content: [null],
      notes: [null],
      noteType: [null],
      storedProcedure: [null],
      chapter: [null],
      order: [null],
      slideClass: [null],
      chartType: [null],
      tableName: [null],
      language: [null],
    });
  }

  public convert(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  getKpis() {
    return this.http.get<Kpi[]>(this.apiUrl + '/kpi', {
      observe: 'response',
    });
  }

  getTextSlides() {
    return this.http.get<TextSlides[]>(this.apiUrl + '/text_slides', {
      observe: 'response',
    });
  }

  kpiEdit(id) {
    return this.http.get<Kpi[]>(this.apiUrl + '/kpi/' + id, {
      observe: 'response',
    });
  }

  textSlideEdit(id) {
    return this.http.get<TextSlides[]>(this.apiUrl + '/text_slide/' + id, {
      observe: 'response',
    });
  }

  showModal(id): void {
    this.modalLoading = true;
    this.submitButtonLoading = false;
    this.kpiEdit(id)
      .pipe()
      .subscribe((res) => {
        this.editKpi = res.body;

        this.editForm = this.formBuilder.group({
          id: [this.editKpi.id],
          description: [this.editKpi.description, [Validators.required]],
          benchmark: [this.editKpi.benchmark, [Validators.required]],
          greenDescription: [this.editKpi.greenDescription],
          yellowDescription: [this.editKpi.yellowDescription],
          redDescription: [this.editKpi.redDescription],
        });

        this.modalLoading = false;
      });
    this.isVisibleModal = true;
  }

  showModalTextSlide(id): void {
    this.modalTextSlideLoading = true;
    this.isVisibleModalTextSlide = true;

    this.textSlideEdit(id)
      .pipe()
      .subscribe((res) => {
        this.editTextSlide = res.body;
        this.modalTextSlideLoading = false;

        if (this.sysLanguage == 'RO') {
          this.editTextSlideForm = this.formBuilder.group({
            id: [this.editTextSlide.id],
            title: [this.editTextSlide.title, [Validators.required]],
            content: [this.editTextSlide.content],
            notes: [this.editTextSlide.notes],
            noteType: [this.editTextSlide.noteType],
            storedProcedure: [this.editTextSlide.storedProcedure],
            chapter: [this.editTextSlide.chapter],
            order: [this.editTextSlide.order],
            slideClass: [this.editTextSlide.slideClass],
            chartType: [this.editTextSlide.chartType],
            tableName: [this.editTextSlide.tableName],
            language: [this.sysLanguage],
          });
        }
        else {
          this.editTextSlideForm = this.formBuilder.group({
            id: [this.editTextSlide.id],
            title: [this.editTextSlide.title_en, [Validators.required]],
            content: [this.editTextSlide.content_en],
            notes: [this.editTextSlide.notes_en],
            noteType: [this.editTextSlide.noteType],
            storedProcedure: [this.editTextSlide.storedProcedure],
            chapter: [this.editTextSlide.chapter],
            order: [this.editTextSlide.order],
            slideClass: [this.editTextSlide.slideClass],
            chartType: [this.editTextSlide.chartType],
            tableName: [this.editTextSlide.tableName],
            language: [this.sysLanguage],
          });
        }
      });
  }

  handleOk(): void {
    this.isConfirmLoading = true;
    this.isVisibleModal = false;
  }

  handleCancel(): void {
    this.isVisibleModal = false;
  }
  handleTextSlideCancel(): void {
    this.isVisibleModalTextSlide = false;
  }

  submitFormKpi() {
    this.submitButtonLoading = true;

    for (const i in this.editForm.controls) {
      this.editForm.controls[i].markAsDirty();
      this.editForm.controls[i].updateValueAndValidity();
    }

    // stop here if form is invalid
    if (this.editForm.invalid) {
      return;
    }

    this.editservice
      .editKPI(this.editForm.value)
      .pipe()
      .subscribe({
        next: () => {
          this.loadingKpi = true;
          // this.isVisibleModal = false;
          this.submitButtonLoading = false;
          this.message.create('success', 'Câmpul a fost salvat.');
          this.getKpis()
            .pipe()
            .subscribe((res) => {
              this.kpi = res.body;
              this.loadingKpi = false;
            });
        },
        error: (error) => {
          console.log(error);
          this.message.create('warning', error);
          this.submitButtonLoading = false;
        },
      });
  }

  submitFormTextSlide() {
    this.submitTextSlideButtonLoading = true;

    for (const i in this.editTextSlideForm.controls) {
      this.editTextSlideForm.controls[i].markAsDirty();
      this.editTextSlideForm.controls[i].updateValueAndValidity();
    }

    // stop here if form is invalid
    if (this.editTextSlideForm.invalid) {
      return;
    }

    this.editservice
      .editTextSlide(this.editTextSlideForm.value)
      .pipe()
      .subscribe({
        next: () => {
          this.loadingTextSlide = true;
          // this.isVisibleModalTextSlide = false;
          this.submitTextSlideButtonLoading = false;
          this.message.create('success', 'Câmpul a fost salvat.');
          this.getTextSlides()
            .pipe()
            .subscribe((res) => {
              this.textSlides = res.body;
              this.loadingTextSlide = false;
            });
        },
        error: (error) => {
          console.log(error);
          this.message.create('warning', error);
          this.submitTextSlideButtonLoading = false;
        },
      });
  }
  changeLanguage(language: string): void {
      this.sysLanguage = language;
  }
}
